const LoginForm = {
  fields: {
    email: {
      label: 'Email',
      placeholder: 'Email',
      dataTestId: 'email',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
      dataTestId: 'password',
    },
  },
  actions: {
    submitButton: {
      label: 'Continue',
      dataTestId: 'login-button',
    },
  },

  messages: {},
};

export default LoginForm;
